import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=43f9d32d&scoped=true&"
var script = {}
import style0 from "./errorPage.vue?vue&type=style&index=0&id=43f9d32d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f9d32d",
  null
  
)

export default component.exports